module.exports = __webpack_public_path__ + "static/media/18.9b15b65c.jpg";